import {PreparedRouteType} from "@Route/types/PreparedRoute.type"
import RouteType from "@Route/types/Route.type"

export const displayTicketType = (route: PreparedRouteType|RouteType) => {
    return true
    // return route.status.providerId !== 23
}